//export const API_URL = "http://Ms-MacBook-Air.local:4242"
export const API_URL = "https://pena.savants.com.mx"
//export const API_URL = "http://10.0.0.32:4242"
//export const API_URL = "http://Ms-MacBook-Pro.local:4242" 
